export default function IconKindergarten() {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
    >
      <rect x="24" y="24" width="4" height="32" />
      <rect x="48" y="24" width="4" height="32" />
      <circle cx="38" cy="28" r="4" />
      {/* eslint-disable-next-line max-len */}
      <path d="M37.82,33h.37A3.82,3.82,0,0,1,42,36.82V43a0,0,0,0,1,0,0H34a0,0,0,0,1,0,0V36.82A3.82,3.82,0,0,1,37.82,33Z" />
      <rect
        x="36"
        y="30"
        width="4"
        height="28"
        transform="translate(82 6) rotate(90)"
      />
      <rect
        x="45"
        y="6.68"
        width="4"
        height="28"
        transform="translate(-0.86 39.29) rotate(-45)"
      />
      <rect
        x="27.82"
        y="6.68"
        width="4"
        height="28"
        transform="translate(23.36 -15.03) rotate(45)"
      />
      {/* eslint-disable-next-line max-len */}
      <path d="M7.44,56H6V52H7.44a8.86,8.86,0,0,0,6.61-2.86L17.76,45a9.32,9.32,0,0,1,6.94-3H26v4H24.7A5,5,0,0,0,21,47.61l-3.71,4.13A13.16,13.16,0,0,1,7.44,56Z" />
    </svg>
  );
}
